var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 156,
    viewBox: "0 0 272 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 272,
    height: 156,
    transform: "translate(-0.171)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0.171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hi-five",
    transform: "translate(52.549 1.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(27.049 8.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M53.159,110.061a5.972,5.972,0,0,1,4.112-.974,9.331,9.331,0,0,1,1.461.3h0S67.5,101,72.5,97.427a9.454,9.454,0,0,1,5.573-2,100.44,100.44,0,0,0,8.17-8.414v-.3a59.069,59.069,0,0,0-5.357-13.8c-1.163-2.327-5.573-9.28-.352-9.253,1.948,0,4.68,2.787,6.3,5.3-1.813-4.518-3.084-8.63-4.978-13.175-.893-2.164-4-11.282,1.7-11.146h.812a2.5,2.5,0,0,1,1.677-3.03c3.138-1.272,4.545,1.867,5.763,3.571l.027.027c.3-4.085,5.519-2.246,7.007,2.408l.027.108a2.53,2.53,0,0,1,1.975.216c-.135-.649-1.082-2.354-1.326-3.436-.541-2.381-.081-5.384,2.841-4.572,5.411,1.515,7.954,12.391,9.009,16.774a54.9,54.9,0,0,0-2.624-11.633c-.73-2.191-3.409-5.925-2.245-8.306,1.353-2.732,5.276-.812,6.628.758,4.6,5.194,4.9,13.257,6.087,19.723a82.183,82.183,0,0,0-1-12.066c-.622-3.977-2.083-8.9-.243-10.632,3.3-3.084,5.817,1.786,6.547,4.518,2.137,8.224,2.083,18.1,1.19,26.73h0c.974-1.542,2-3.057,3.084-4.464,1.84-2.408,5.194-8.387,9.2-7.061,3.869,1.3,0,7.359-1.055,9.794-1.813,4.22-3.219,8.6-5.059,12.8-.893,2.056-3.382,6.114-4.031,9.09,0,0,6.412,8.576,9.6,12.445l.108.027a10.681,10.681,0,0,0,.46-1c4.87,3.977,8.306,8.224,12.58,12.337.676.676,1.217,1.136,1.623,1.569.189-.243.379-.46.541-.7,7.846-10.091,11.309-22.59,11.823-34.954a95.225,95.225,0,0,0-1.38-19.614,57.309,57.309,0,0,0-5.3-16.665,36.894,36.894,0,0,0-11.877-13.527,53.018,53.018,0,0,0-17.125-7.332c-12.688-3.219-27.108-4.383-39.77-.433C77.156,21.837,67.823,30.2,60.843,39.883,47.505,58.361,41.12,83.792,50.562,105.056,51.347,106.734,52.212,108.438,53.159,110.061Z",
    transform: "translate(-46.066 -15.599)",
    fill: "#f4f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M148.018,180.87a102.945,102.945,0,0,1-9.171-11.552c.325-.108.649-.189.947-.3-1.542-1.786-9.956-11.8-10.362-14.772-.514.541-1.028,1.055-1.515,1.569-4.356,4.653-7.467,8.766-11.471,13.744l-.379.216c-.3,3.436-2.732,5.763-5.221,8.657a103.669,103.669,0,0,1-7.656,7.765,77.182,77.182,0,0,0,20.291.541,158,158,0,0,0,20.21-2.868c1.921-.433,3.869-.92,5.763-1.488C148.91,181.817,148.4,181.276,148.018,180.87Z",
    transform: "translate(-68.473 -69.986)",
    fill: "#f4f6f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    d: "M1.558,192.179c.812-3.6,4.951-7.71,7.9-9.929,1.19-.92,3.192-2.516,4.789-1.786,1.921.866,1.786,4.518,3.247,5.871.433-4.166,3.9-9.929,6.953-12.715,2.029-1.84,4.491-1.407,6.6.243,2.922-1.786,4.9-4.924,8.739-4.464,3.274.406,6.628,2.462,9.063,4.626,3.6,3.219,6.628,6.114,8.711,10.524,1.488,3.165,1.813,6.547,2.57,10.064,1,4.734-.974,7.521-6.033,7.467-.027,1.786-1.434,4.22-2.435,5.681-1.569,2.3-3.3,2.137-5.221,3.544-1.326.974-2.056,2.651-3.057,3.95a58.387,58.387,0,0,0-4.545,5.844",
    transform: "translate(-1.558 -67.378)",
    fill: "none",
    stroke: "#377dff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M82.133,216.73a3.88,3.88,0,0,1,1.028-1.272",
    transform: "translate(-33.164 -85.463)",
    fill: "none",
    stroke: "#377dff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M18.471,105.771c2.164,5.221,2.327,7.494-1.867,10.713,4.058-3.815,7.2-2.462,10.064,1.461-2.408-3.192-2.732-3.977-2.354-6.222.216-1.217,2.191-3.3,3.328-4.112C25.424,109.125,21.177,111.263,18.471,105.771Z",
    transform: "translate(-7.46 -42.437)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M98.693,140.173c3.571-3.03,10.01-10.5,10.01-10.5",
    transform: "translate(-39.66 -51.814)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M125.046,135.751c3.977-5.005,7.115-9.09,11.471-13.744,1.542-1.65,3.409-3.3,4.329-5.221,1.028-2.164,1.136-6.3,1.136-8.711,0-9.415-.866-19.777-4.193-28.677-.947-2.516-3.328-9.685-5.952-10.93-2.57-1.217-3.49,1.055-3.192,2.841.812,4.9,2.029,9.875,2.516,14.176",
    transform: "translate(-49.998 -27.669)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M66.863,160.865s8.766-8.387,13.771-11.958c4.734-3.382,8.982-2.191,13.5,1.461,4.356,3.544,6.818,8.955,7.629,14.474.676,4.626-2.191,7.278-5.14,10.686-2.246,2.624-8.5,8.928-10.876,10.281",
    transform: "translate(-27.175 -58.573)",
    fill: "#377dff",
    stroke: "#377dff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x1: 6.601,
    y1: 0.758,
    transform: "translate(30.95 32.222)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    x1: 3.869,
    y1: 2.543,
    transform: "translate(40.581 15.719)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M128.356,65.174c-1.7-5.411-8.441-7.034-6.737,0,.622,2.543.785,6.168,1.434,8.766.6,2.408,1.353,6.791,1.353,6.791",
    transform: "translate(-48.546 -24.674)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M138.045,152.558a4.846,4.846,0,0,0,2.11-.758",
    transform: "translate(-55.097 -60.492)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M116.51,61.7c-1.244-1.7-2.624-4.843-5.763-3.571-2.868,1.163-1.542,3.95-.568,6.168,1.867,4.329,4.518,14.69,4.518,14.69",
    transform: "translate(-43.707 -23.631)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M160.17,151.267a2.348,2.348,0,0,1,2.273-.758",
    transform: "translate(-63.775 -59.959)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M105.564,63.3c-5.708-.135-2.6,8.982-1.7,11.146,1.894,4.545,3.138,8.657,4.978,13.175.514,1.272,1.677,4.356,1.677,4.356",
    transform: "translate(-41.04 -25.777)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M173.881,93.853a63.461,63.461,0,0,1,5.032-7.765c1.84-2.408,5.194-8.387,9.2-7.061,3.869,1.3,0,7.359-1.055,9.794-1.813,4.22-3.219,8.6-5.059,12.8-1.136,2.651-4.924,8.549-4.058,11.255",
    transform: "translate(-69.154 -31.872)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M106.841,117.736a59.069,59.069,0,0,0-5.357-13.8c-1.163-2.327-5.573-9.28-.352-9.253,1.948,0,4.68,2.787,6.3,5.3",
    transform: "translate(-39.638 -38.089)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M160.055,77.307c.893-8.63.974-18.505-1.19-26.73-.7-2.732-3.246-7.6-6.547-4.518-1.867,1.731-.379,6.655.243,10.632a86.075,86.075,0,0,1,1,12.066c-1.19-6.466-1.488-14.5-6.087-19.723-1.353-1.542-5.276-3.49-6.628-.758-1.163,2.354,1.515,6.087,2.246,8.306a54.1,54.1,0,0,1,2.624,11.633c-1.055-4.383-3.6-15.259-9.009-16.774-2.922-.812-3.382,2.191-2.841,4.572.243,1.055,1.19,2.787,1.326,3.436",
    transform: "translate(-53.381 -18.626)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M180.647,131.278s6.439,8.6,9.6,12.472",
    transform: "translate(-71.808 -52.442)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M146.369,154.2c.46,3.3,10.335,14.772,10.335,14.772",
    transform: "translate(-58.362 -61.435)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M187.053,205.665a10.434,10.434,0,0,0,.758,7.278c1,2.137,3.788,3.328,4.545,5.519.676,1.975.108,4.058,1.542,5.9.947,1.217,5.871,4.248,7.386,4.383",
    transform: "translate(-74.183 -81.622)",
    fill: "none",
    stroke: "#00c9db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M221.914,175.661c9.28,1,16.016,9.5,20.913,16.665-.054-2.6,2.489-3.49,4.464-3.328,4.275.352,4.734,4.166,7.061,6.845",
    transform: "translate(-87.995 -69.852)",
    fill: "none",
    stroke: "#00c9db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M173.63,161.634a42.2,42.2,0,0,1-11.769,6.033,100.555,100.555,0,0,0,9.171,11.552c1.353,1.488,4.248,4.247,6.277,4.626,2.273.433,5.33-1.244,7.061-2.462A74.139,74.139,0,0,0,194.191,173a15.876,15.876,0,0,0,3.923-5.952c.622-2.354-.162-2.678-2.137-4.6-4.247-4.112-7.71-8.36-12.58-12.337C182.125,153.464,177.985,158.631,173.63,161.634Z",
    transform: "translate(-64.439 -59.829)",
    fill: "#00c9db",
    stroke: "#00c9db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M245.892,110.489A15.553,15.553,0,0,1,242.1,117.2c-1.786,1.677-5.194,1.731-7.548,1.894,7.44,0,5.925,4.41,5.492,10.064.866-4.491,1.19-6.006,2.516-7.548,1.759-2,4.22-1.434,6.277-2.3-2.814.054-4.626.433-4.734-2.651C244.025,114.466,245.189,112.627,245.892,110.489Z",
    transform: "translate(-92.954 -44.288)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    y1: 3.355,
    x2: 4.383,
    transform: "translate(137.408 23.591)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    y1: 4.058,
    x2: 3.544,
    transform: "translate(134.432 14.203)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    y1: 3.544,
    x2: 1.001,
    transform: "translate(95.123 0)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    x1: 1.515,
    y1: 4.329,
    transform: "translate(70.774 4.626)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.116
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3487ce80da425dca8cc2aa51511ebf81.svg";
export { ForwardRef as ReactComponent };